<div class="join-org-container">
  <div class="header">
    <img src="assets/logo/logo-full-green.png" alt="Check Plus Logo" class="logo" />
    <div class="back-link" (click)="goBack()">
      <mat-icon>chevron_left</mat-icon>
      <span>Back</span>
    </div>
  </div>

  <div class="form-content">
    <h1 class="title">Join Organization</h1>
    <h2 class="subtitle">Don’t have an account</h2>

    <form [formGroup]="joinForm" (ngSubmit)="onJoin()">
      <div class="input-group">
        <label class="form-label">Invite code</label>
        <div class="input-wrapper">
          <mat-icon class="prefix-icon">link</mat-icon>
          <input
            formControlName="inviteCode"
            placeholder="Enter Invite code or paste invite link"
            type="text"
            class="custom-input"
          />
        </div>
      </div>

      <button
        gbui-button
        type="submit"
        class="submit-button"
        [disabled]="joinForm.invalid || isLoading"
        [busy]="isLoading"
        context="primary"
      >
        Join Organization
      </button>
    </form>
  </div>
</div>
